import { getHttpClient } from "@/http-client";

const baseUrl = "api/boss/nipr";
export function validateNpn(body) {
  return getHttpClient().post(`${baseUrl}/validate`, body);
}
